



















import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import { DailyTableData } from '@/model/dashboard/DailyTableData'

interface ComponentData {
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
}

export default Vue.extend({
  name: 'DashboardTable',

  components: {
    AgGridVue
  },

  props: {
    dashboardTableLabel: String,

    dashboardTableHeaders: {
      type: Array as () => Array<any>
    },

    dashboardTableData: {
      type: Array as () => Array<DailyTableData>
    },
    dashboardTableDate: String
  },

  data (): ComponentData {
    return {
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('dashboard.employee').toString(), field: 'employee', sort: 'asc' },
          {
            headerName: `${this.$t('dashboard.from').toString()} - ${this.$t('dashboard.to').toString()}`,
            field: 'time',
            width: 130
          },
          {
            headerName: `${this.$t('dashboard.shift').toString()} / ${this.$t('dashboard.absence').toString()}`,
            field: 'entry'
          },
          //{ headerName: this.$t('dashboard.conflict').toString(), field: 'conflict', width: 100},
        ],
      },

      gridFrameworkComponents: {},
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>'
    }
  }

})
